const checkDateRange = (d1, d2) => {
  // To calculate the time difference of two dates
  var Difference_In_Time = d1.getTime() - d2.getTime();

  // To calculate the no. of days between two dates
  var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

  return Difference_In_Days;
};

export { checkDateRange };
